import * as pkg from 'react-helmet-async';

import { metaDefaults } from '@/utils';

const { Helmet } = pkg.default ?? pkg;

/**
 * Meta component for managing document head
 *
 * @param {Object} props - Component props
 * @param {string} [props.url] - Page URL
 * @param {string} props.title - Page title
 * @param {string} [props.description] - Page description
 * @param {boolean} props.robots - Robot tag should be added
 */
const Meta = ({ url, title, description, robots = false }) => {
  const { ogImage, keywords } = metaDefaults;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {robots && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Meta;
